import React from 'react';
import { motion } from 'framer-motion';
const paragraphs = [{
  text: "The objective of 'Snakkefying' the LEO AD Days — Living with Atopic Dermatitis website is to capture attention instantly and guide users from recognition to action — before they lose interest."
}, {
  text: 'At the core of the approach is a simple principle:\npeople will only invest effort if they believe the reward is worth it.'
}, {
  text: "That's why we suggest reverse the traditional website experience.\nWe begin with a lean-back, animated introduction that requires almost no effort, but quickly delivers value — helping users recognize their symptoms and understand what atopic dermatitis is. This early clarity builds trust and creates a sense that the experience is worth continuing."
}, {
  text: 'As users stay and engage, we gradually introduce small interactions and more depth. The journey moves from a simple, guided flow into a more non-linear and personalized experience, where users can explore signs, symptoms, triggers, and solutions in a way that feels relevant to them.'
}, {
  text: 'In this way, effort and complexity are increased only when the user is ready for it.\nThe result is a natural progression:\nstart with clarity, build relevance, and guide users toward action — without overwhelming them.'
}];
export function IntroScreen() {
  return <section className="min-h-screen w-full bg-white flex flex-col items-center justify-center px-6 py-24" data-id="element-247">
      <div className="max-w-3xl w-full mx-auto" data-id="element-248">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="flex items-center gap-4 mb-12" data-id="element-249">
          <img src="https://cdn.magicpatterns.com/uploads/dfRAppH2d2zZ685F7e4fCm/image.png" alt="Snakker" className="h-8" data-id="element-250" />
          <span className="text-slate-300 text-lg" data-id="element-251">×</span>
          <span className="text-lg font-semibold text-slate-700 tracking-wide" data-id="element-252">
            LEO Pharma
          </span>
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} className="text-3xl md:text-5xl font-bold text-slate-900 mb-14 leading-tight" data-id="element-253">
          Living with AD: Objective and approach
        </motion.h1>

        <div className="space-y-6" data-id="element-254">
          {paragraphs.map((p, i) => <motion.p key={i} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: 0.2 + i * 0.1
        }} className="text-base md:text-lg text-slate-700 leading-relaxed whitespace-pre-line" data-id="element-255">
              {p.text}
            </motion.p>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.8
      }} className="mt-16 flex items-center gap-2 text-slate-400 text-sm" data-id="element-256">
          <span data-id="element-257">Scroll to explore</span>
          <motion.span animate={{
          y: [0, 6, 0]
        }} transition={{
          repeat: Infinity,
          duration: 1.5
        }} data-id="element-258">
            ↓
          </motion.span>
        </motion.div>
      </div>
    </section>;
}